<template>
  <div class="con-bak" ref="outCon">
    <div class="column-con">
      <h1 style="margin-top: 200px;">管理界面登录</h1>
      <div class="column-con-inner">
        <span class="text">用户名</span>
        <input type="text" class="input" v-model="account"/>
        <span class="text">密码</span>
        <input type="password" class="input" v-model="passWord"/>
        <div class="button" @click="_login">登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/util/http";
import Cookies from "js-cookie";
import {ElMessage} from "element-plus"

export default {
// eslint-disable-next-line vue/multi-word-component-names
  name: "Login",
  mounted() {
    this.clientHeightCal()
    this._checkToken()
  },
  data() {
    return {
      account: undefined,
      passWord: undefined
    }
  },
  methods: {
    clientHeightCal() {
      this.$refs.outCon.style.height = document.documentElement.clientHeight + 'px';
    },
    _checkToken() {
      http.post('checkToken')
          .then((res) => {
            if (res.data.status === 0) {
              Cookies.set('token', res.data.data.token)
              this._loginStatus()
            }
          })
    },
    _toHome() {
      this.$router.push({
        path: '/AdminHome'
      })
    },
    _loginStatus() {
      http.get('loginStatus')
          .then((res) => {
            if (res.data.status === 0) { // 已登录

              ElMessage.success("已登录")
              this._toHome()
            } else { // 尚未登录

            }
          })
    },
    _login() {
      if (!this.account) {
        ElMessage.warning("账号必须填写")
      }

      if (!this.passWord) {
        ElMessage.warning("密码必须填写")
      }

      http.post('login', {
        account: this.account,
        passWord: this.passWord
      })
          .then((res) => {
            if (res.data.status === 0) {
              ElMessage.success(res.data.content)
              this._toHome()
            } else {
              ElMessage.error(res.data.content)
            }
          })
    }
  }
}
</script>

<style scoped>
.con-bak {
  background: #0091e6;
  width: 100%;
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center
}

.column-con {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

.column-con-inner {
  background: #fff;
  padding: 4em;
  border-radius: 0.3em;
  -webkit-border-radius: 0.3em;
  -o-border-radius: 0.3em;
  -moz-border-radius: 0.3em;
  box-shadow: 0px 0px 15px #545454;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 40px;
  max-width: 400px;
}

.input {
  padding: 9px;
  width: 300px;
  font-size: 1.1em;
  margin: 3px 0px 25px;
  color: #666666;
  background: #f0f0f0;
  border: none;
  font-weight: 400;
  outline: none;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  border-radius: 0.2em;
  -webkit-border-radius: 0.2em;
}

.text {
  color: #333333;
  font-size: 18px;
  margin-bottom: 10px;
}

.button {
  margin-right: 11px;
  background: #0091e6;
  border: none;
  outline: none;
  padding: 8px 30px;
  cursor: pointer;
  height: 30px;
  width: 100px;
  color: #FFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1.1em;
  font-weight: bold;
  border-radius: 0.3em;
  transition: 0.5s all;
  margin: 0 auto;
}
</style>